export default __webpack_public_path__ + "media/src/assets/images/DOT_hazmat_class_9-36007ebff2ceced04a137c1f40be9359.svg";